import { useRef, useState } from 'react';
import './LogoEasterEgg.css';

export function LogoEasterEgg({ children }) {
  const [clickCount, setClickCount] = useState(0);
  const [hearts, setHearts] = useState([]);
  const clickTimeoutRef = useRef(null);

  const handleLogoClick = async (e) => {
    // Increment click counter
    const newClickCount = clickCount + 1;
    setClickCount(newClickCount);

    // Reset counter after 4 seconds of inactivity (more forgiving)
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }
    clickTimeoutRef.current = setTimeout(() => {
      setClickCount(0);
    }, 4000);

    // On 5+ clicks, trigger easter egg
    if (newClickCount >= 5) {
      setClickCount(0); // Reset counter
      await triggerHearts(e);
    }
  };

  const triggerHearts = async (e) => {
    let emoji = '💚'; // Default emoji

    try {
      // Fetch current deployment status
      const response = await fetch('/health/deployment-status');
      if (response.ok) {
        const data = await response.json();
        // Map active_slot to emoji client-side
        if (data.active_slot === 'blue') {
          emoji = '💙';
        } else if (data.active_slot === 'green') {
          emoji = '💚';
        }
      }
    } catch (error) {
      console.warn('Could not fetch deployment status, using default emoji:', error);
    }

    // Generate 5-8 floating hearts from click position
    const heartCount = 5 + Math.floor(Math.random() * 4);
    const clickX = e.clientX || window.innerWidth / 2;
    const clickY = e.clientY || window.innerHeight / 2;
    const newHearts = Array.from({ length: heartCount }, (_, i) => ({
      id: Date.now() + i,
      emoji: emoji,
      x: clickX + (Math.random() - 0.5) * 100,
      y: clickY,
      delay: i * 0.1,
    }));

    setHearts((prev) => [...prev, ...newHearts]);

    // Remove hearts after animation completes (3s)
    setTimeout(() => {
      setHearts((prev) =>
        prev.filter(
          (heart) =>
            !newHearts.map((h) => h.id).includes(heart.id)
        )
      );
    }, 3000);
  };

  return (
    <div className="logo-easter-egg" onClick={handleLogoClick}>
      {children}
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="floating-heart"
          style={{
            '--x': `${heart.x}px`,
            '--y': `${heart.y}px`,
            '--delay': `${heart.delay}s`,
          }}
        >
          {heart.emoji}
        </div>
      ))}
    </div>
  );
}
